import { queryInterestsPerJoruney } from "@/modules/lead-page/api/lead-page.v2.api";
import { useInfiniteQuery } from "@tanstack/react-query";

interface InterestsQueryParams {
  journeyUids?: string[];
}

const PAGE_SIZE = 20;

export const useInterestsInfiniteQuery = ({
  journeyUids,
}: InterestsQueryParams) => {
  const query = useInfiniteQuery({
    queryKey: ["interests", { journeyUids }],
    queryFn: ({ pageParam = 1 }) => {
      return queryInterestsPerJoruney({
        journeyUids,
        pagination: {
          page: pageParam,
          pageSize: PAGE_SIZE,
        },
      });
    },
    getNextPageParam: (lastPage) => {
      const { page, total } = lastPage?.data || {};
      const totalPages = Math.ceil(total / PAGE_SIZE);
      if (page && totalPages && page < totalPages) {
        return page + 1;
      }

      return undefined;
    },
    enabled: !!journeyUids,
    select: (data) => {
      const allResults = data.pages.flatMap((page) => page.data.results);
      return {
        ...data,
        results: allResults,
      };
    },
  });

  return query;
};
